import { WebShopDefinition } from '@work4all/models/lib/Classes/WebShopDefinition.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';

import { EntityTableV8, IEntityTableV8 } from '../entity-table/EntityTableV8';
import { useEntityDataTableV8 } from '../entity-table/use-entity-data-table-v8';
import schema from '../schemata/webShopDefinition-table-schema.json';

const defaultSort = [{ field: 'name', direction: SortDirection.DESCENDING }];

export function WebShopTable(props: IEntityTableV8) {
  const dataTable = useEntityDataTableV8<WebShopDefinition, never>({
    ...props,
    schema: schema as never,
    defaultSort,
    enableURLState: false,
  });

  return (
    <EntityTableV8
      {...props}
      {...dataTable}
      actions={{
        remove: undefined,
        createWidget: false,
        groupingEnabled: false,
      }}
      overrides={{ areas: null }}
    />
  );
}
